import React from "react";
import Icon from "@mdi/react";

export default function CategoryTabsGem({ categories, activeCategory, onChange }) {
  return (
    <div style={{
      background: "white",
      borderRadius: 14,
      boxShadow: "0 4px 24px rgba(0,0,0,.07)",
      marginBottom: "2.5rem",
      overflow: "hidden",
      border: "1px solid rgba(0,0,0,.05)",
    }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          overflowX: "auto",
          overflowY: "hidden",
          padding: "12px 16px",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "none",
        }}
      >
        {categories.map((c) => (
          <button
            key={c.label}
            type="button"
            className={`cat-tab${activeCategory === c.label ? " active" : ""}`}
            onClick={() => onChange(c.label)}
          >
            <Icon path={c.icon} size={0.8} />
            {c.label}
          </button>
        ))}
      </div>
    </div>
  );
}
